import { object, string } from "yup";

const editProfileSchema = object().shape({
    change: string().required("Le champ est requis"),
});

export default editProfileSchema;
